import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * ProtectedRoute - Wrapper component for routes that require authentication
 * 
 * If user is not authenticated, redirects to login with returnUrl parameter
 * If user is authenticated, renders the protected component
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isAuthenticated - Whether user is authenticated
 * @param {React.Component} props.children - The protected component to render
 */
function ProtectedRoute({ isAuthenticated, children }) {
  const location = useLocation();

  if (!isAuthenticated) {
    // Save the current location they were trying to access
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    console.log('[ProtectedRoute] User not authenticated, redirecting to login with returnUrl:', returnUrl);
    
    return <Navigate to={`/?returnUrl=${returnUrl}`} replace />;
  }

  return children;
}

export default ProtectedRoute;

